<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="流水号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>流水号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="盈亏仓库" v-if="getIsView()"> 
                <el-input disabled v-model="form.warehouseName"></el-input>
                <!-- <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehouses" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
              <span class="viewText" v-else>盈亏仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWareshouseName" label="一级库房" v-if="getIsView()">
                <el-input disabled v-model="form.oneLevelWareshouseName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>一级库房:{{ form.oneLevelWareshouseName }} </span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item prop="warehouseCategoryName" label="库房类别">
                <el-input disabled v-model="form.warehouseCategoryName"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="盈亏日期" v-if="getIsView()">
                <el-date-picker disabled v-model="form.date" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="盈亏日期" style="width:100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>盈亏日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stockCategory" label="库存类型" v-if="getIsView()">
                <el-radio-group disabled v-model="form.stockCategory">
                  <el-radio :label="0">普通库存</el-radio>
                  <el-radio :label="1">备货库存</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>库存类型:{{ form.stockCategory==1?'备货库存':'普通库存' }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="profitNumber" label="盘盈数量" v-if="getIsView()">
                <el-input disabled placeholder="盘盈数量" v-model="form.profitNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>盘盈数量:{{ form.profitNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="profitAmount" label="盘盈金额" v-if="getIsView()">
                <el-input disabled placeholder="盘盈金额" v-model="form.profitAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>盘盈金额:{{ form.profitAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="lossNumber" label="盘亏数量" v-if="getIsView()">
                <el-input disabled placeholder="盘亏数量" v-model="form.lossNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>盘亏数量:{{ form.lossNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="lossAmount" label="盘亏金额" v-if="getIsView()">
                <el-input disabled placeholder="盘亏金额" v-model="form.lossAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>盘亏金额:{{ form.lossAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="盈亏金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>盈亏金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input disabled placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">盈亏明细</span>
          </div>

          <!-- <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
          </div> v-else -->
          <div style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" show-overflow-tooltip fixed width="130"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" fixed width="110"></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>

            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="price" label="单价" width="100"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="100"></el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="100"></el-table-column>
            <el-table-column prop="inventoryNumber" label="实点数量" width="80"></el-table-column>
            <el-table-column prop="stockNumber" label="库存数量" width="80"></el-table-column>
            <el-table-column prop="diffNumber" label="盈亏数量" width="80"></el-table-column>
            <el-table-column prop="result" label="盘点结果" width="80"></el-table-column>
            <el-table-column prop="amount" label="小计" width="100"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="100"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="120"></el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="100"></el-table-column>
            <el-table-column prop="locationName" label="货位" width="100"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  SpdGetStockProfitLossById,
  SpdRejectStockProfitLoss,
  SpdSaveStockProfitLoss
} from "@/api";
// import { StockCategoryOptions } from "@/enum";
// import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin,tagCodeMixin],
  components: {
    // SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      GetDataAction: SpdGetStockProfitLossById,
      SaveDataAction: SpdSaveStockProfitLoss,
      reject: SpdRejectStockProfitLoss,
      form: {},
      // StockCategoryOptions: StockCategoryOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择盘点仓库', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择盘点日期', trigger: 'blur' }
        ],
        // supplierName: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
      },
      childFormRules: {
        productName: [{ required: true, message: "请选择产品", trigger: "blur" }],
        // manufactureDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
        // validityDate: [{ required: true, message: "请选择有效期", trigger: "blur" }],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        // price: [
        //   { required: true, message: "请输入计费价", trigger: "blur" },
        // ],
        inventoryNumber: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      isScan: false,
      loading: false,
      // patientList: []
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getWarehouses('')
    // this.getSuppliers('');
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        "warehouseCategory": "",
        "warehouseId": '',
        warehouseName: '',
        warehouseManagerId: '',
        warehouseManagerName: '',
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        "balanceStatus": 2,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      // this.$set(
      //   this.childForm,
      //   "patientIdArr",
      //   this.childForm.patientInfos.map((e) => e.id)
      // );

      // var that = this
      // setTimeout(function () {
      //   that.$refs.number.focus()
      //   that.$refs.number.select()
      // }, 1)
      // this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "stockNumber": 0,
        "inventoryNumber": 0,
        "diffNumber": 0,
        "price": 0,
        "amount": 0,
        "remark": "",
        patientIdArr: [],
        patientInfos: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    pushChildForm (close) {
      let result = true
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
        }
      });
      return result
    },
    childNumberChange () {
      this.childForm.diffNumber = this.childForm.inventoryNumber - this.childForm.stockNumber
      this.childForm.result = this.childForm.diffNumber < 0 ? '盘亏' : this.childForm.diffNumber > 0 ? '盘盈' : '正常'
      // this.childForm.amount = this.accMul(this.childForm.price, this.childForm.inventoryNumber)
      // this.childForm.unChargeNumber = this.childForm.number
      this.autoAmount();
    },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.inventoryNumber * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.inventoryNumber * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },


  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
